// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"06813ad1","453":"db0ce1ab","455":"1d78cf86","644":"748a139f"}[chunkId] + ".chunk.js";
};